<section class="featured-section">
    <h2 class="featured-title">Featured</h2>

    <div class="featured-hero">
        <div class="featured-content">
            <h1 class="featured-heading">
                YoGamez Pro, the<br />home of champions.
            </h1>
            <p class="featured-tagline">Play. Compete. Win. Repeat.</p>
        </div>

        <div class="featured-character">
            <!-- Character image is part of the background -->
        </div>

        <button class="explore-btn" [routerLink]="['/games']">
            Explore
        </button>
    </div>
</section>
